import { combineReducers } from 'redux'

import manageCampaignReducer from "./manage-campaign";
import authReducer from "./auth-reducer";

export default combineReducers({manageCampaignReducer, authReducer})